/**
 * 视频详情相关
 */

import axios from "../utils/http"


// 视频详情列表
const videoList = (params) => {
  return axios.request({
    data: {
      ...params,
    },
    method: "post",
    url: "/v7/courseware/detail",
  })
}

const getVideoAuth = (params) => {
  return axios.request({
    data: {
      ...params,
    },
    method: "get",
    url: "/video/getVideoPlayAuth",
  })
}
const getDetailList = (params) => {
  const { userid } = params
  return axios.request({
    data: {
      ...params,
    },
    headers: { userid: userid },
    method: "get",
    url: "/sell/goods/detail",
  })
}
const getAudioText = (params) => { // 获取音频文稿
    const { userid } = params
    return axios.request({
      data: {
        goods_id: params.goods_id,
        course_id: params.course_id
      },
      method: "get",
      headers: { userid: userid },
      url: "/sell/goods/audioText",
    })
  }
export default {
  videoList,
  getVideoAuth,
  getDetailList,
  getAudioText
}
